import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCreditLimitReport } from "./autogen/AutogenLayoutCreditLimitReport";

export class CreditLimitReport extends AutogenLayoutCreditLimitReport {
    override onLoad(): void {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxSort.selectedItem = this.textboxSort.items[0];
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }
}
